import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function OrderingPayment(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(
    SvgIcon,
    {
      ...rest,
      "data-tidal": "TidalIllustration",
      "data-tidal-illustration": "OrderingPayment",
      sx,
      viewBox,
      children: [
        /* @__PURE__ */ jsx("path", { d: "M27.117 7.645H5v28.437h22.117V7.645Z", fill: theme.vars.palette.secondary.main }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M24.01 3H8.21a3.169 3.169 0 0 0-3.16 3.16v1.58h22.12V6.16A3.169 3.169 0 0 0 24.009 3Z",
            fill: theme.vars.palette.primary.dark
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M17.69 6.16h-3.16c-.474 0-.79-.316-.79-.79 0-.474.316-.79.79-.79h3.16c.474 0 .79.316.79.79 0 .474-.316.79-.79.79Z",
            fill: theme.vars.palette.secondary.main
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M24.01 40.916H8.21a3.169 3.169 0 0 1-3.16-3.16v-1.58h22.12v1.58a3.169 3.169 0 0 1-3.16 3.16Z",
            fill: theme.vars.palette.primary.dark
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M17.69 39.335h-3.16c-.474 0-.79-.316-.79-.79 0-.474.316-.79.79-.79h3.16c.474 0 .79.316.79.79 0 .474-.316.79-.79.79Z",
            fill: theme.vars.palette.secondary.main
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M16.085 29.814a7.917 7.917 0 1 0 0-15.834 7.917 7.917 0 0 0 0 15.834Z",
            fill: theme.vars.palette.primary.dark
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M16.576 21.4v-1.983c.26 0 .508.105.692.29a.998.998 0 0 1 .286.702.5.5 0 0 0 .144.35.486.486 0 0 0 .692 0 .499.499 0 0 0 .143-.35 2 2 0 0 0-.573-1.403 1.945 1.945 0 0 0-1.384-.58v-.496a.5.5 0 0 0-.144-.35.486.486 0 0 0-.692 0 .5.5 0 0 0-.143.35v.495c-.52 0-1.018.21-1.385.581a1.997 1.997 0 0 0-.573 1.403c0 .526.206 1.03.573 1.402.367.372.865.581 1.385.581v1.984a.973.973 0 0 1-.693-.29.998.998 0 0 1-.286-.702.5.5 0 0 0-.144-.35.486.486 0 0 0-.692 0 .5.5 0 0 0-.143.35c0 .526.206 1.03.573 1.402.367.372.865.581 1.385.581v.496a.5.5 0 0 0 .143.35.486.486 0 0 0 .692 0 .5.5 0 0 0 .144-.35v-.496c.519 0 1.017-.209 1.384-.58a2 2 0 0 0 0-2.805 1.945 1.945 0 0 0-1.384-.581Zm-1.958-.991a1 1 0 0 1 .286-.701.973.973 0 0 1 .693-.29V21.4a.972.972 0 0 1-.693-.29.998.998 0 0 1-.286-.702Zm1.958 3.967v-1.984c.26 0 .508.105.692.29a.998.998 0 0 1 0 1.403.972.972 0 0 1-.692.29Z",
            fill: theme.vars.palette.secondary.main
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M38.097 26.122 36.281 35.6H25.854a1.52 1.52 0 0 1-1.5-1.185l-1.58-6.319c-.238-1.027.473-1.974 1.5-1.974h13.823Z",
            fill: theme.vars.palette.primary.light
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M27.75 33.23c-.316 0-.553-.157-.71-.473l-1.58-3.16c-.159-.395 0-.869.315-1.027.395-.158.87 0 1.027.316l1.58 3.16c.158.395 0 .869-.316 1.027-.079.158-.158.158-.316.158Zm4.74 0c-.08 0-.237 0-.316-.078-.395-.158-.553-.632-.316-1.027l1.58-3.16c.157-.395.631-.553 1.026-.316.395.158.553.632.316 1.027l-1.58 3.16a.83.83 0 0 1-.71.395Zm-2.37 0c-.474 0-.79-.315-.79-.79v-3.159c0-.474.316-.79.79-.79.474 0 .79.316.79.79v3.16c0 .474-.316.79-.79.79Z",
            fill: theme.vars.palette.secondary.main
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M33.279 44.29a2.37 2.37 0 1 0 0-4.74 2.37 2.37 0 0 0 0 4.74Zm-7.108 0a2.37 2.37 0 1 0 0-4.74 2.37 2.37 0 0 0 0 4.74Z",
            fill: theme.vars.palette.primary.light
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M34.307 39.629H23.801c-.473 0-.79-.316-.79-.79 0-.474.317-.79.79-.79h10.506c.395 0 .711-.237.79-.632l2.212-11.454 1.264-5.845c.237-1.106 1.185-1.896 2.37-1.896h1.026c.474 0 .79.316.79.79 0 .474-.316.79-.79.79h-1.027c-.395 0-.71.237-.79.632l-1.263 5.845-2.212 11.375c-.237 1.185-1.185 1.974-2.37 1.974Z",
            fill: theme.vars.palette.secondary.main
          }
        )
      ]
    }
  );
}
OrderingPayment.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "OrderingPayment"
};
validateTidalLicense();
export {
  OrderingPayment
};
//# sourceMappingURL=OrderingPayment.js.map
